import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiResponse } from '@app/_models';
import { UserRoleService, AlertService } from '@app/_services';

@Injectable({
	providedIn: 'root'
})

@Injectable()
export class UserRoleListResolver  {

	constructor(
		private router: Router,
		private userRoleService: UserRoleService,
		private alertService: AlertService) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): Observable<ApiResponse>
	{
		return this.userRoleService.findAll();
	}
}
